export default __webpack_public_path__ + "static/media/celebrate.f0f58cc35f2c3a167f4c9747fc3e2a10.svg";